module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n6n8n7r-9d1c84df39485484f2a677f6918e4875.svg";